window.heroScramble = function () {
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%&*';
  var title = document.querySelector('.hero-title');
  var sub = document.querySelector('.hero-sub');
  if (!title || !sub) return;

  var titleText = 'SPARK ONE';
  var subLine1 = "THIS ISN'T OUR";
  var subLine2 = 'FIRST DIMENSION';

  title.textContent = '';
  sub.innerHTML = '';
  title.style.opacity = '1';
  title.style.transform = 'translateY(0)';

  function scrambleTo(el, text, duration, delay, callback) {
    setTimeout(function () {
      var len = text.length;
      var totalFrames = Math.ceil(duration / 16);
      var resolveEvery = Math.max(1, Math.floor(totalFrames / len));
      var iterations = 0;
      var resolved = [];
      for (var i = 0; i < len; i++) resolved[i] = false;

      var timer = setInterval(function () {
        var result = '';
        var allDone = true;
        for (var i = 0; i < len; i++) {
          if (text[i] === ' ') {
            resolved[i] = true;
            result += ' ';
          } else if (resolved[i]) {
            result += text[i];
          } else if (iterations >= i * resolveEvery) {
            resolved[i] = true;
            result += text[i];
          } else {
            allDone = false;
            result += chars[Math.floor(Math.random() * chars.length)];
          }
        }
        el.textContent = result;
        iterations++;
        if (allDone || iterations >= totalFrames) {
          clearInterval(timer);
          el.textContent = text;
          if (callback) callback();
        }
      }, 16);
    }, delay);
  }

  // Scramble title first
  scrambleTo(title, titleText, 500, 0, function () {
    // Then scramble subtitle line by line
    sub.style.opacity = '1';
    sub.style.transform = 'translateY(0)';

    var span1 = document.createElement('span');
    span1.id = 'sub-line1';
    var br = document.createElement('br');
    var span2 = document.createElement('span');
    span2.id = 'sub-line2';
    sub.appendChild(span1);
    sub.appendChild(br);
    sub.appendChild(span2);

    scrambleTo(span1, subLine1, 400, 100);
    scrambleTo(span2, subLine2, 400, 300);
  });
};
